import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { createListButtonStyles } from "@insite/content-library/Widgets/MyLists/MyListsCreateListButton";
import { css } from "styled-components";

wishListCardStyles.actionAddToCartButton={
    color: "primary",
    css: css`
        white-space: nowrap;
        width: 100%;
        padding: 0 10px;
    `, // keep text from wrapping
}
createListButtonStyles.createListButton ={
        color: "primary",
    }